<template>
  <el-row
    type="flex"
    justify="center"
  >
    <el-col
      :xs="{ span: 20 }"
      :sm="{ span: 20 }"
      :md="{ span: 16 }"
    >
      <el-container class="card auto-width">
        <el-row>
          <el-col>
            <span class="title">{{ strings.title }}</span>
          </el-col>
          <el-col class="py-2">
            <el-steps
              :active="1"
              finish-status="success"
              align-center
            >
              <el-step />
              <el-step />
              <el-step />
              <el-step />
              <el-step />
            </el-steps>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-table
              v-if="searchResults"
              :data="searchResults.results"
              height="250"
              stripe
              class="el-table--scrollable-y"
              style="width: 100%"
            >
              <el-table-column
                prop="first_name"
                label="First Name"
                align="center"
              />
              <el-table-column
                prop="last_name"
                label="Last Name"
                align="center"
              />
              <el-table-column
                label="Phone Number"
                align="center"
              >
                <template slot-scope="scope">
                  {{ $helpers.phoneMask(scope.row.phone_number) }}
                </template>
              </el-table-column>
              <el-table-column
                label="Action"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="info"
                    class="text-center"
                    @click="select(scope.row)"
                  >
                    Select
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row class="mt-1">
          <el-col
            :span="12"
            class="text-left"
          >
            <router-link
              to="/search"
            >
              <el-button
                type="default"
              >
                {{ strings.backBtn }}
              </el-button>
            </router-link>
          </el-col>
        </el-row>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ResultsPage',
  data() {
    return {
      strings: {
        title: 'Search Results',
        backBtn: 'Back'
      }
    };
  },
  computed: {
    ...mapGetters('shopper', ['searchResults']),
  },
  mounted() {
    if (!this.searchResults) {
      this.$router.push('/search');
    }
  },
  methods: {
    select(shopper) {
      // Store this shopper and send user to Edit Page
      this.$store.dispatch('shopper/storeSelected', shopper);
      this.$router.push('/edit-customer');
    }
  }
};
</script>

<style>

</style>